import React from "react";
import PrivateRoute from "PrivateRoutes";
import { REPORT } from "./components";

const routes = () => (
	<PrivateRoute exact path="/reporting/campaign-summary" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/CampaignSummary/routes.js